import { Directive } from '@angular/core';

@Directive({ standalone: true, selector: '[ndpInputHint]' })
export class InputHintDirective {}
